import { GuardError } from '../../../errors/GuardError';
import { showAlert } from '../../../slices/alertSlice';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageChatsBlocked } from '../actions';
import { EFirstMessageResponseStatus, IAssertDependencies, TFirstMessageResponse } from '../types';

export const assertBlockedStatus =
  (response: TFirstMessageResponse, { domain, telemetry }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.Blocked) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendChatsBlocked);

      dispatch(setFirstMessageChatsBlocked());
      dispatch(showAlert({ message: 'Чаты заблокированы' }));

      const error = new GuardError({
        message: 'Не удалось отправить первое сообщение: переписка с получателем заблокирована',
        domain,
        details: { errorCode: response.status },
      });

      logger.error(error);
    }
  };
